import { createRouter, createWebHistory } from "vue-router";

const routes = [
  { path: "/", name: "Home", component: () => import("@/views/HomePage.vue") },
  {
    path: "/schedules-journey",
    name: "journeyPage",
    component: () => import("@/components/Journey"),
  },
  {
    path: "/passenger-booking-details",
    name: "BookingDetails",
    component: () => import("@/components/BookDetails.vue"),
  },
  {
    path: "/passenger-payments",
    name: "Payments",
    component: () => import("@/components/Payments.vue"),
  },
  {
    path: "/seat-details",
    name: "SeatDetails",
    component: () => import("@/components/SeatDetails.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
  {
    path: "/ticket",
    name: "Tickets",
    component: () => import("@/views/accounts/UserTicketsPage.vue"),
  },
  {
    path: "/user-profile",
    name: "Profile",
    component: () => import("@/views/accounts/UserProfilePage.vue"),
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "NotFound",
  //   component: () => import("@/views/NotFound.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      const section = document.querySelector(to.hash);
      if (section) {
        return {
          el: to.hash,
          behavior: "smooth",
        };
      }
    }
    return { top: 0 };
  },
});
router.beforeEach((to, from, next) => {
  if (from.name === "SeatDetails" && to.name !== "Home") {
    next({ name: "Home" });
  } else {
    next();
  }
});

export default router;
